<footer class="bg-light p-3 text-center">
    <div class="logo"></div>
    <p>

    </p>
  </footer>
